import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { initSentryReact } from "@project/sentry/react";
import { ensureFilePondRegistered } from "@apps/dashboard/lib/filepond-setup";
import { initProductAnalytics } from "@apps/dashboard/lib/analytics";
import App from "@apps/dashboard/App";
import { ThemeProvider } from "@apps/dashboard/theme/theme-provider";
import "./index.css";
import "driver.js/dist/driver.css";
import "sonner/dist/styles.css";

ensureFilePondRegistered();

// Inicializar Sentry antes de renderizar
initSentryReact();
initProductAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);

